import { post } from './http';

const STORAGE_KEY = 'geppro_payment_settings';
const API_BASE = process.env.REACT_APP_API_URL || '';
const USE_MOCK = !API_BASE || API_BASE === '';

function saveToLocalStorage(data) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (err) {
    console.error('Failed to save payment settings:', err);
  }
}

export async function postPaymentSettings(payload) {
  if (USE_MOCK) {
    // Mock: save to localStorage and return success
    return new Promise((resolve) => {
      setTimeout(() => {
        saveToLocalStorage(payload);
        resolve({ success: true, settings: payload });
      }, 200);
    });
  }
  try {
    return await post('/api/payment-settings', { settings: payload });
  } catch (err) {
    console.warn('API failed, using mock:', err);
    saveToLocalStorage(payload);
    return { success: true, settings: payload };
  }
}

export async function getPaymentSettings() {
  if (USE_MOCK) {
    return new Promise((resolve) => {
      setTimeout(() => {
        try {
          const json = localStorage.getItem(STORAGE_KEY);
          const settings = json ? JSON.parse(json) : null;
          resolve({ success: true, settings });
        } catch {
          resolve({ success: true, settings: null });
        }
      }, 150);
    });
  }
  try {
    const res = await fetch(`${API_BASE}/api/payment-settings`);
    if (!res.ok) throw new Error('Failed to fetch');
    return await res.json();
  } catch (err) {
    console.warn('API failed, using mock:', err);
    try {
      const json = localStorage.getItem(STORAGE_KEY);
      const settings = json ? JSON.parse(json) : null;
      return { success: true, settings };
    } catch {
      return { success: true, settings: null };
    }
  }
}

const paymentService = { postPaymentSettings, getPaymentSettings };
export default paymentService;
